import React from 'react';
import { motion } from 'framer-motion';
import { Cpu, Shield, Zap, Wifi } from 'lucide-react';
const features = [{
  icon: Cpu,
  title: 'עיבוד קוונטי בחלל',
  desc: 'מחשבי-על זעירים המעבדים נתונים בזמן אמת במסלול.'
}, {
  icon: Shield,
  title: 'הצפנה פוסט-קוונטית',
  desc: 'אבטחת מידע ברמה צבאית חסינה בפני איומי העתיד.'
}, {
  icon: Zap,
  title: 'הנעה יונית מתקדמת',
  desc: 'מערכות הנעה חשמליות המאפשרות תמרון מדויק ויעיל.'
}, {
  icon: Wifi,
  title: 'תקשורת לייזר',
  desc: 'פס רחב בין-לווייני להעברת טרה-בייטים של מידע בשניות.'
}];
export function Technology() {
  return <section id="technology" className="py-24 relative z-10 overflow-hidden" data-id="element-194">
      <div className="max-w-7xl mx-auto px-6" data-id="element-195">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-196">
          {/* Text Content */}
          <div className="w-full lg:w-1/2" data-id="element-197">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-198">
              טכנולוגיה{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-cyan-400" data-id="element-199">
                פורצת גבולות
              </span>
            </h2>
            <p className="text-gray-400 text-lg mb-10 leading-relaxed" data-id="element-200">
              הפיתוחים שלנו משלבים חומרה מתקדמת, בינה מלאכותית וחומרים מורכבים
              כדי ליצור את הדור הבא של תשתיות החלל.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-201">
              {features.map((feat, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: idx * 0.1
            }} className="bg-white/5 border border-white/10 rounded-2xl p-5 hover:bg-white/10 transition-colors" data-id="element-202">
                  <feat.icon className="w-8 h-8 text-cyan-400 mb-4" data-id="element-203" />
                  <h4 className="text-white font-bold mb-2" data-id="element-204">{feat.title}</h4>
                  <p className="text-sm text-gray-400" data-id="element-205">{feat.desc}</p>
                </motion.div>)}
            </div>
          </div>

          {/* Animated Diagram */}
          <div className="w-full lg:w-1/2 flex justify-center items-center perspective-[1000px] h-[400px] md:h-[500px]" data-id="element-206">
            <div className="relative w-full h-full max-w-[400px] max-h-[400px] flex items-center justify-center" style={{
            transformStyle: 'preserve-3d',
            transform: 'rotateX(60deg)'
          }} data-id="element-207">
              {/* Core */}
              <div className="absolute w-16 h-16 bg-gradient-to-br from-cyan-400 to-blue-600 rounded-full shadow-[0_0_50px_#06b6d4] animate-pulse" style={{
              transform: 'rotateX(-60deg)'
            }} data-id="element-208" />

              {/* Ring 1 */}
              <motion.div animate={{
              rotateZ: 360
            }} transition={{
              duration: 10,
              repeat: Infinity,
              ease: 'linear'
            }} className="absolute w-[200px] h-[200px] rounded-full border-2 border-dashed border-cyan-500/40" data-id="element-209">
                <div className="absolute top-0 left-1/2 w-4 h-4 bg-white rounded-full shadow-[0_0_10px_white] -translate-x-1/2 -translate-y-1/2" style={{
                transform: 'rotateX(-60deg)'
              }} data-id="element-210" />
              </motion.div>

              {/* Ring 2 */}
              <motion.div animate={{
              rotateZ: -360
            }} transition={{
              duration: 15,
              repeat: Infinity,
              ease: 'linear'
            }} className="absolute w-[300px] h-[300px] rounded-full border border-violet-500/40" data-id="element-211">
                <div className="absolute bottom-1/4 right-0 w-3 h-3 bg-violet-400 rounded-full shadow-[0_0_10px_#8b5cf6] translate-x-1/2" style={{
                transform: 'rotateX(-60deg)'
              }} data-id="element-212" />
                <div className="absolute top-1/4 left-0 w-3 h-3 bg-violet-400 rounded-full shadow-[0_0_10px_#8b5cf6] -translate-x-1/2" style={{
                transform: 'rotateX(-60deg)'
              }} data-id="element-213" />
              </motion.div>

              {/* Ring 3 */}
              <motion.div animate={{
              rotateZ: 360
            }} transition={{
              duration: 25,
              repeat: Infinity,
              ease: 'linear'
            }} className="absolute w-[400px] h-[400px] rounded-full border border-blue-500/20" data-id="element-214">
                <div className="absolute top-1/2 right-0 w-5 h-5 bg-blue-400 rounded-full shadow-[0_0_15px_#3b82f6] translate-x-1/2 -translate-y-1/2" style={{
                transform: 'rotateX(-60deg)'
              }} data-id="element-215" />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}